import { useEffect, useRef } from 'react';
import useVideoContext from '../hooks/useVideoContext';
export default function AudioTrack(_ref) {
  var track = _ref.track;

  var _useVideoContext = useVideoContext(),
      audioSinkDeviceId = _useVideoContext.audioSinkDeviceId;

  var audioEl = useRef(new Audio());
  useEffect(function () {
    audioEl.current = track.attach();
    audioEl.current.setAttribute('data-cy-audio-track-name', track.name);
    document.body.appendChild(audioEl.current);
    return function () {
      return track.detach().forEach(function (el) {
        el.remove();
        el.srcObject = null; // recommended by Twilio to prevent leaks in  CHrome: https://github.com/twilio/twilio-video.js/releases/tag/2.15.3
      });
    };
  }, [track]);
  useEffect(function () {
    audioEl.current && audioEl.current.setSinkId && audioEl.current.setSinkId(audioSinkDeviceId)["catch"](function (error) {
      return console.error('setSInkId error', error);
    });
  }, [audioSinkDeviceId]);
  return null;
}
var remoteAudioContext; //AudioContext
//https://github.com/twilio/twilio-video.js/issues/1586
//https://bugs.webkit.org/show_bug.cgi?id=230902#c18

export function AudioTrackWithGain(_ref2) {
  var track = _ref2.track,
      gain = _ref2.gain;
  useEffect(function () {
    if (!remoteAudioContext) remoteAudioContext = new (window.AudioContext || window.webkitAudioContext)();
    var audioNode = remoteAudioContext.createMediaStreamSource(new MediaStream([track.mediaStreamTrack]));
    var gainNode = remoteAudioContext.createGain(); // Adjust this value depending on your customers' preference

    gainNode.gain.value = gain;
    audioNode.connect(gainNode);
    gainNode.connect(remoteAudioContext.destination); // when headphones are discounnedted the context get suspended.
    // try to resume it if we can

    remoteAudioContext.onstatechange = function () {
      if (remoteAudioContext.state === 'suspended') {
        remoteAudioContext.resume()["catch"](function (e) {
          return console.error('failed to resume audio context', e);
        });
      }
    };

    return function () {
      remoteAudioContext.onstatechange = null;
      audioNode.disconnect();
      gainNode.disconnect();
    };
  }, [track]);
  return null;
}